
import Vue from "vue";
import { mapState } from "vuex";
import { download } from "@/utils";

export default Vue.extend({
  data() {
    return {};
  },
  computed: {
    ...mapState("app", {
      language: "language",
      isCN: "isCN",
      isMobile: "isMobile"
    }),
    ...mapState("assets", {
      url: "url",
      oss: "oss"
    }),
    communityImages(): string[] {
      return [
        this.oss.cyberboard_glacier_r2_swiper_01,
        this.oss.cyberboard_glacier_r2_swiper_02,
        this.oss.cyberboard_glacier_r2_swiper_03,
        this.oss.cyberboard_glacier_r2_swiper_04,
        this.oss.cyberboard_glacier_r2_swiper_05,
        this.oss.cyberboard_glacier_r2_swiper_06,
        this.oss.cyberboard_glacier_r2_swiper_07,
        this.oss.cyberboard_glacier_r2_swiper_17,
        this.oss.cyberboard_glacier_r2_swiper_18,
        this.oss.cyberboard_glacier_r2_swiper_19,
        this.oss.cyberboard_glacier_r2_swiper_20,
        this.oss.cyberboard_glacier_r2_swiper_08,
        this.oss.cyberboard_glacier_r2_swiper_09,
        this.oss.cyberboard_glacier_r2_swiper_10,
        this.oss.cyberboard_glacier_r2_swiper_11,
        this.oss.cyberboard_glacier_r2_swiper_12,
        this.oss.cyberboard_glacier_r2_swiper_13,
        this.oss.cyberboard_glacier_r2_swiper_14,
        this.oss.cyberboard_glacier_r2_swiper_15,
        this.oss.cyberboard_glacier_r2_swiper_16
      ];
    },
    communityNames(): string[] {
      return this.isCN
        ? [
            "by Lachlan",
            "by Lachlan",
            "by Lachlan",
            "by Lachlan",
            "by Lachlan",
            "by Lachlan",
            "by Lachlan",
            "by naogol",
            "by naogol",
            "by naogol",
            "by naogol",
            "by 鬼鬼",
            "by 鬼鬼",
            "by 鬼鬼",
            "by hyst",
            "by hyst",
            "by hyst",
            "by 方圆",
            "by 方圆",
            "by 方圆"
          ]
        : [
            "by Lachlan",
            "by Lachlan",
            "by Lachlan",
            "by Lachlan",
            "by Lachlan",
            "by Lachlan",
            "by Lachlan",
            "by naogol",
            "by naogol",
            "by naogol",
            "by naogol",
            "by 鬼鬼",
            "by 鬼鬼",
            "by 鬼鬼",
            "by hyst",
            "by hyst",
            "by hyst",
            "by 方圆",
            "by 方圆",
            "by 方圆"
          ];
    }
  },
  methods: {
    onDownload() {
      download(this.oss.pdf_cyberboard_xmas);
    },
    onVerify() {
      window.open(this.$paths.verify + "cyberboard/", "_blank");
    }
  }
});
